import axios from 'axios'
import { GID_BASE_BLOG } from '~/js/constants/gid-base'

// Shopify APIのmetaobjectsクエリは最大250件まで取得可能
export const METAOBJECTS_PAGE_SIZE = 250

const SHOPIFY_API_VERSION = 'unstable'
const STOREFRONT_API_ENDPOINT = `/api/${SHOPIFY_API_VERSION}/graphql.json`

export const getStorefrontAccessToken = () => {
  const elementSettings = document.getElementById('js-data')
  return elementSettings?.dataset.storefrontAccessToken || ''
}

export const getStorefrontHeaders = () => {
  const storefrontAccessToken = getStorefrontAccessToken()
  return {
    'Content-Type': 'application/json',
    'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
  }
}

export const postStorefrontQuery = async ({ query, variables }) => {
  const { data } = await axios.post(
    STOREFRONT_API_ENDPOINT,
    {
      query,
      variables,
    },
    {
      headers: getStorefrontHeaders(),
    }
  )

  return data?.data
}

/**
 * Blog IDからそのブログのarticle一覧を取得する
 * @param {string|number} blogId - ブログのID
 * @param {number} first - 取得件数（デフォルト: 50）
 * @returns {Promise<Array>} article の配列
 */
export const getArticlesByBlogId = async (blogId, first = 50) => {
  const blogGid = `${GID_BASE_BLOG}${blogId}`

  const query = `
    query($blogId: ID!, $first: Int!) {
      blog(id: $blogId) {
        articles(first: $first, sortKey: PUBLISHED_AT, reverse: true) {
          edges {
            node {
              id
              title
              handle
              publishedAt
              image {
                url
              }
              excerpt
              tags
              blog {
                handle
              }
            }
          }
        }
      }
    }`

  const data = await postStorefrontQuery({
    query,
    variables: {
      blogId: blogGid,
      first,
    },
  })

  return (data?.blog?.articles?.edges || []).map(({ node }) => ({
    ...node,
    id: node.id.split('/').pop(),
    url: `/blogs/${node.blog.handle}/${node.handle}`,
  }))
}
